export enum MetricStatus {
    Healthy = "healthy",
    Warning = "warning",
    Critical = "critical",
}

export enum MetricTrend {
    Up = "up",
    Down = "down",
    Stable = "stable",
}

export enum FrictionArea {
    PoorRequirements = "poor_requirements",
    CommunicationGaps = "communication_gaps",
    WeakOwnership = "weak_ownership",
    DependencyBlockers = "dependency_blockers",
    ProcessGaps = "process_gaps",
    TeamCulture = "team_culture",
}
